import styled from 'styled-components'

export const Wrapper = styled.div`
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  > .MuiPaper-root {
    height: calc(100% - 64px);
  }
`

export const FunctionsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  padding: 20px;

  button {
    font-size: 16px !important;
    padding: 6px 16px !important;
  }
`
